import { makeVar } from '@apollo/client';

/**
 * 모바일환경에서 화면 하단 버튼 그룹을 가리지 않도록 스낵바의 bottom을 설정하는 변수
 */
export const snackbarBottom = makeVar<number>(0);
